import { render, staticRenderFns } from "./SamplingOrderCreationFieldSelection.vue?vue&type=template&id=50971573&scoped=true&lang=html&"
import script from "./SamplingOrderCreationFieldSelection.vue?vue&type=script&lang=js&"
export * from "./SamplingOrderCreationFieldSelection.vue?vue&type=script&lang=js&"
import style0 from "./SamplingOrderCreationFieldSelection.vue?vue&type=style&index=0&id=50971573&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50971573",
  null
  
)

export default component.exports